import React from "react";
import Bubble from "../../../What/components/BubblesGrid/components/Bubble";
const BubbleChoices = ({
  availableItems,
  selectedItems,
  onSelectedItems,
  className,
  mode,
  title,
  bubbleClassName,
}) => {
  mode = mode ? mode : "multiple";
  const handleSelectedItem = (item) => {
    let isCurrentlySelected = selectedItems.indexOf(item) > -1;
    if (mode === "multiple") {
      if (isCurrentlySelected) {
        let newSelectedItems = selectedItems.filter((i) => i !== item);
        onSelectedItems(newSelectedItems);
      } else {
        onSelectedItems([...selectedItems, item]);
      }
    } else {
      if (isCurrentlySelected) {
        onSelectedItems([]);
      } else {
        onSelectedItems([item]);
      }
    }
  };

  className = "grid gap-2 " + className;

  return (
    <div>
      {title ? <h2 className="mb-8">{title}</h2> : null}
      <div className={className}>
        {availableItems.map((item, index) => {
          let isSelected = selectedItems.indexOf(item) > -1;
          return (
            <div className="w-full pb-[100%] relative">
              <div className="w-full h-full absolute top-0 left-0">
                <Bubble
                  key={index}
                  isSelected={isSelected}
                  onClick={() => handleSelectedItem(item)}
                  shouldAnimate={true}
                  cellNo={index} //Only for animation
                  className={bubbleClassName}
                >
                  <h4 className="md:text-[1.5vw] p-4">
                    {item.replace("-", " ")}
                  </h4>
                </Bubble>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BubbleChoices;
